import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";

export const save = ({ uuid, firmName, title, Admissions }) => async (dispatch) => {
    try {
        const res = await api.post(`/attorneys`, { uuid, firmName, title, Admissions });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/attorneys/i/${uuid}`) : { data: { success: false } };
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/attorneys/i/${uuid}`) : { data: { success: false } };
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}